import React, { useRef, useEffect } from 'react';

import { TextField as Input, FormHelperText } from '@material-ui/core';
import { useField } from '@unform/core';

import * as S from './styles';

export default function TextField({ name, ...rest }) {
  const inputRef = useRef(null);

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  return (
    <S.Wrapper error={!!error}>
      <Input
        fullWidth
        inputRef={inputRef}
        defaultValue={defaultValue}
        onFocus={clearError}
        error={!!error}
        variant="outlined"
        size="small"
        InputLabelProps={{ shrink: true }}
        {...rest}
      />

      <FormHelperText>{error}</FormHelperText>
    </S.Wrapper>
  );
}
